import { saturationColors, type SaturationLevel } from "@/lib/theme";

interface SaturationBadgeProps {
  level: SaturationLevel | null;
  size?: "sm" | "md";
}

export function SaturationBadge({ level, size = "sm" }: SaturationBadgeProps) {
  if (!level) return null;
  const config = saturationColors[level];
  if (!config) return null;

  return (
    <span
      className={`inline-flex items-center font-brand uppercase tracking-wider rounded ${
        size === "sm" ? "text-[9px] px-1.5 py-0.5" : "text-[10px] px-2 py-1"
      }`}
      style={{
        color: config.color,
        backgroundColor: config.bg,
        border: level === "cracked_door" ? `1px solid ${config.color}30` : undefined,
      }}
    >
      {config.label}
    </span>
  );
}
